export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0040_thumb.ea46d87c.jpg";